export default {
  main: '#2B2B2B',
  secondary: '#44FFB1',
  contrastingColor: '#ffffff',
  priceColor: '#2B2B2B',
  entryBackground: '#000000',
  menuBackgroundColor: '#000000',
  menuTextColor: '#44FFB1',
};
